import { goToPage } from '../../actions'

export const actions = {
  goToPage,
}
export const selectors = null
